import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { InvocaService } from 'src/app/base/services/invoca.service';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private invoke: InvocaService,
    private messageService: MessageService,
    private sessionService: SessionService
  ) {}

  async iniciarSesion(run: number, nroPasaporte: string, hash: string, extranjero: boolean): Promise<any> {
    let response = {};
    await this.invoke.httpInvoke('public/iniciarSesion', { 
      run: run,
      nroPasaporte: nroPasaporte,
      hash: hash,
      extranjero: extranjero
    })
    .then(res => {
      
      if(res.status && res.status === 'OK'){
        this.sessionService.setToken(res.data.token);
        this.sessionService.setUser(res.data.userData);
      }

      if (res.status && res.status === 'ERROR') {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: res.msg });
      } else {
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: res.msg });
      }
      response = res;
    })
    return response;
  }

  async recuperarCodigo(run: number, nroPasaporte: string, extranjero: boolean): Promise<any> {
    return this.invoke.httpInvoke('public/recuperarCodigo', { 
      run: run,
      nroPasaporte: nroPasaporte,
      extranjero: extranjero
    })
  }


}
